var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCh3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.168 0.914062C58.0006 0.914062 61.918 4.83158 61.918 9.66406V21.3307C61.918 23.5718 61.0753 25.616 59.6899 27.1641C61.0753 28.7122 61.918 30.7562 61.918 32.9974V44.6641C61.918 49.4967 58.0006 53.4141 53.168 53.4141H35.668V59.2474H61.918C63.5288 59.2474 64.8346 60.5532 64.8346 62.1641C64.8346 63.7749 63.5288 65.0807 61.918 65.0807H3.58464C1.97382 65.0807 0.667969 63.7749 0.667969 62.1641C0.667969 60.5532 1.97382 59.2474 3.58464 59.2474H29.8346V53.4141H12.3346C7.50216 53.4141 3.58464 49.4967 3.58464 44.6641V32.9974C3.58464 30.7562 4.42711 28.7122 5.81268 27.1641C4.42711 25.616 3.58464 23.5718 3.58464 21.3307V9.66406C3.58464 4.83158 7.50216 0.914062 12.3346 0.914062H53.168ZM12.3346 24.2474H53.168C54.7788 24.2474 56.0846 22.9415 56.0846 21.3307V9.66406C56.0846 8.05325 54.7788 6.7474 53.168 6.7474H12.3346C10.7238 6.7474 9.41797 8.05325 9.41797 9.66406V21.3307C9.41797 22.9415 10.7238 24.2474 12.3346 24.2474ZM12.3346 30.0807C10.7238 30.0807 9.41797 31.3865 9.41797 32.9974V44.6641C9.41797 46.2749 10.7238 47.5807 12.3346 47.5807H53.168C54.7788 47.5807 56.0846 46.2749 56.0846 44.6641V32.9974C56.0846 31.3865 54.7788 30.0807 53.168 30.0807H12.3346Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh3);
export default __webpack_public_path__ + "static/media/ch3.e9aeee908d2a683739b9cec6083aad0d.svg";
export { ForwardRef as ReactComponent };